import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { axiosErrorMessageHelper } from 'shared/utils/axiosErrorMessageHelper'
import { IMeetingAgendaModel } from '../../../models/BoardMeeting'
import agendaService from './agenda.service'
import { IBaseState, ICaseError } from './selector'

export const agendaCaseAdapter = createEntityAdapter<
  IMeetingAgendaModel,
  string
>({
  selectId: (c) => c.caseId,
  sortComparer: (a, b) => a.order - b.order,
})

const mamangeAgenda = createSlice({
  name: 'manage/agenda',
  initialState: agendaCaseAdapter.getInitialState<IBaseState>({
    loading: false,
    error: null,

    casesError: [],
    focusedCaseId: null,
  }),

  reducers: {
    updateMany: agendaCaseAdapter.upsertMany,
    addMany: agendaCaseAdapter.addMany,
    addOne: agendaCaseAdapter.addOne,
    removeOne: agendaCaseAdapter.removeOne,
    updateOne: agendaCaseAdapter.upsertOne,
    updateAttributesOnMany: agendaCaseAdapter.updateMany,
    updateAttributesOnOne: agendaCaseAdapter.updateOne,

    checkCaseAndUpdateIfInAgenda(_, _action: PayloadAction<string>) {},

    // Handle individual case error
    addCaseError(state, action: PayloadAction<ICaseError>) {
      state.casesError.push(action.payload)
    },
    removeCaseError(state, action: PayloadAction<string>) {
      state.casesError = state.casesError.filter(
        (error) => error.id !== action.payload
      )
    },

    setFocusedCaseId(state, action: PayloadAction<string>) {
      state.focusedCaseId = action.payload
    },
    clearCaseReferance(state) {
      state.focusedCaseId = null
    },
  },

  extraReducers: (builder) => {
    // Replaces agendaFetchRequested, agendaFetchSuccess, agendaFetchError
    builder.addMatcher(
      agendaService.endpoints.fetchAgenda.matchPending,
      (state) => {
        state.error = null
        state.loading = true
      }
    )
    builder.addMatcher(
      agendaService.endpoints.fetchAgenda.matchFulfilled,
      (state, action) => {
        state.loading = false

        agendaCaseAdapter.setAll(state, action.payload)
      }
    )
    builder.addMatcher(
      agendaService.endpoints.fetchAgenda.matchRejected,
      (state, action) => {
        state.loading = false

        const err = axiosErrorMessageHelper(action.payload)
        state.error = err || 'Det skjedde en feil ved henting av agenda'
      }
    )
  },
})

export default mamangeAgenda
